"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Divider", {
    enumerable: true,
    get: function() {
        return Divider;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Divider = function(props) {
    var text = props.text, className = props.className;
    var classes = (0, _classnames.default)("relative", className);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: classes
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "absolute inset-0 flex items-center",
        "aria-hidden": "true"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "w-full border-t border-gray-300"
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: "relative flex justify-center"
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: "px-2 bg-white text-sm text-gray-500"
    }, text)));
};

//# sourceMappingURL=Divider.js.map